import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './theme/styles.css';
import { ThemeProvider, createTheme, responsiveFontSizes } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
import { notifyFromServer } from './Components/notifierBridge';

axios.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  config.headers['ngrok-skip-browser-warning'] = 'true';
  return config;
});

// Show the server's `message` for any successful mutation (POST/PUT/DELETE,
// including 200/207). The backend sends user-useful messages here (e.g.
// "user already exists"); error flag -> error toast, otherwise success. GETs are
// excluded to avoid noise, and HTTP errors still flow to each page's handleError.
//
// 202 is ALSO excluded: "Accepted" means the server queued the work and the real
// outcome arrives later by polling (see useJobPoller). Its message is a handshake
// ("processing started"), not a result — toasting it tells the user the job
// succeeded when it has barely begun. The page owning the job reports progress
// and the final outcome itself.
axios.interceptors.response.use((response) => {
  try {
    const method = ((response.config && response.config.method) || '').toLowerCase();
    const data = response.data;
    if (response.status === 202) return response;
    if (method && method !== 'get' && data && typeof data === 'object') {
      const msg = data.message || data.msg;
      if (msg) {
        const isErr = data.error === 1 || data.error === true;
        notifyFromServer(msg, isErr ? 'error' : 'success');
      }
    }
  } catch (e) {
    // Never let notification logic break a successful response.
  }
  return response;
});

// Global theme: palette + zoom-independent typography.
// Typography is rem-based (relative to the browser/OS root font size) so the UI
// scales uniformly across machines and display-scaling settings instead of being
// pinned to fixed pixels. htmlFontSize=16 matches the browser default; fontSize=14
// is the MUI baseline. responsiveFontSizes() then makes the heading variants
// (h1–h6, subtitle, body) step down at smaller breakpoints automatically.
let globalTheme = createTheme({
  palette: {
    primary: { main: '#0000ff' }, // blue
    secondary: { main: '#ff0000' } // red
  },
  typography: {
    htmlFontSize: 16,
    fontSize: 13
  }
});
globalTheme = responsiveFontSizes(globalTheme);

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={globalTheme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
  
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
